/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AbsenceEntry } from '../models/absence-entry';
import { apiV0AbsenceEntryApproveAbsenceEntryPost } from '../fn/absence-entry/api-v-0-absence-entry-approve-absence-entry-post';
import { ApiV0AbsenceEntryApproveAbsenceEntryPost$Params } from '../fn/absence-entry/api-v-0-absence-entry-approve-absence-entry-post';
import { apiV0AbsenceEntryCreateMultiplePost } from '../fn/absence-entry/api-v-0-absence-entry-create-multiple-post';
import { ApiV0AbsenceEntryCreateMultiplePost$Params } from '../fn/absence-entry/api-v-0-absence-entry-create-multiple-post';
import { apiV0AbsenceEntryDeleteByIdDelete } from '../fn/absence-entry/api-v-0-absence-entry-delete-by-id-delete';
import { ApiV0AbsenceEntryDeleteByIdDelete$Params } from '../fn/absence-entry/api-v-0-absence-entry-delete-by-id-delete';
import { apiV0AbsenceEntryDeleteMultipleDelete } from '../fn/absence-entry/api-v-0-absence-entry-delete-multiple-delete';
import { ApiV0AbsenceEntryDeleteMultipleDelete$Params } from '../fn/absence-entry/api-v-0-absence-entry-delete-multiple-delete';
import { apiV0AbsenceEntryGetAllAbsenceEntriesByCompanyGet$Json } from '../fn/absence-entry/api-v-0-absence-entry-get-all-absence-entries-by-company-get-json';
import { ApiV0AbsenceEntryGetAllAbsenceEntriesByCompanyGet$Json$Params } from '../fn/absence-entry/api-v-0-absence-entry-get-all-absence-entries-by-company-get-json';
import { apiV0AbsenceEntryGetAllAbsenceEntriesByCompanyGet$Plain } from '../fn/absence-entry/api-v-0-absence-entry-get-all-absence-entries-by-company-get-plain';
import { ApiV0AbsenceEntryGetAllAbsenceEntriesByCompanyGet$Plain$Params } from '../fn/absence-entry/api-v-0-absence-entry-get-all-absence-entries-by-company-get-plain';
import { apiV0AbsenceEntryRejectAbsenceEntryPost } from '../fn/absence-entry/api-v-0-absence-entry-reject-absence-entry-post';
import { ApiV0AbsenceEntryRejectAbsenceEntryPost$Params } from '../fn/absence-entry/api-v-0-absence-entry-reject-absence-entry-post';
import { apiV0AbsenceEntryUpdateAbsenceEntryPost } from '../fn/absence-entry/api-v-0-absence-entry-update-absence-entry-post';
import { ApiV0AbsenceEntryUpdateAbsenceEntryPost$Params } from '../fn/absence-entry/api-v-0-absence-entry-update-absence-entry-post';

@Injectable({ providedIn: 'root' })
export class AbsenceEntryService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiV0AbsenceEntryGetAllAbsenceEntriesByCompanyGet()` */
  static readonly ApiV0AbsenceEntryGetAllAbsenceEntriesByCompanyGetPath = '/api/v0/absenceEntry/getAllAbsenceEntriesByCompany';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0AbsenceEntryGetAllAbsenceEntriesByCompanyGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0AbsenceEntryGetAllAbsenceEntriesByCompanyGet$Plain$Response(params?: ApiV0AbsenceEntryGetAllAbsenceEntriesByCompanyGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AbsenceEntry>>> {
    const obs = apiV0AbsenceEntryGetAllAbsenceEntriesByCompanyGet$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0AbsenceEntryGetAllAbsenceEntriesByCompanyGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0AbsenceEntryGetAllAbsenceEntriesByCompanyGet$Plain(params?: ApiV0AbsenceEntryGetAllAbsenceEntriesByCompanyGet$Plain$Params, context?: HttpContext): Observable<Array<AbsenceEntry>> {
    const resp = this.apiV0AbsenceEntryGetAllAbsenceEntriesByCompanyGet$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<AbsenceEntry>>): Array<AbsenceEntry> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0AbsenceEntryGetAllAbsenceEntriesByCompanyGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0AbsenceEntryGetAllAbsenceEntriesByCompanyGet$Json$Response(params?: ApiV0AbsenceEntryGetAllAbsenceEntriesByCompanyGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AbsenceEntry>>> {
    const obs = apiV0AbsenceEntryGetAllAbsenceEntriesByCompanyGet$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0AbsenceEntryGetAllAbsenceEntriesByCompanyGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0AbsenceEntryGetAllAbsenceEntriesByCompanyGet$Json(params?: ApiV0AbsenceEntryGetAllAbsenceEntriesByCompanyGet$Json$Params, context?: HttpContext): Observable<Array<AbsenceEntry>> {
    const resp = this.apiV0AbsenceEntryGetAllAbsenceEntriesByCompanyGet$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<AbsenceEntry>>): Array<AbsenceEntry> => r.body)
    );
  }

  /** Path part for operation `apiV0AbsenceEntryCreateMultiplePost()` */
  static readonly ApiV0AbsenceEntryCreateMultiplePostPath = '/api/v0/absenceEntry/createMultiple';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0AbsenceEntryCreateMultiplePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV0AbsenceEntryCreateMultiplePost$Response(params?: ApiV0AbsenceEntryCreateMultiplePost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = apiV0AbsenceEntryCreateMultiplePost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0AbsenceEntryCreateMultiplePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV0AbsenceEntryCreateMultiplePost(params?: ApiV0AbsenceEntryCreateMultiplePost$Params, context?: HttpContext): Observable<void> {
    const resp = this.apiV0AbsenceEntryCreateMultiplePost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiV0AbsenceEntryUpdateAbsenceEntryPost()` */
  static readonly ApiV0AbsenceEntryUpdateAbsenceEntryPostPath = '/api/v0/absenceEntry/updateAbsenceEntry';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0AbsenceEntryUpdateAbsenceEntryPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV0AbsenceEntryUpdateAbsenceEntryPost$Response(params?: ApiV0AbsenceEntryUpdateAbsenceEntryPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = apiV0AbsenceEntryUpdateAbsenceEntryPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0AbsenceEntryUpdateAbsenceEntryPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV0AbsenceEntryUpdateAbsenceEntryPost(params?: ApiV0AbsenceEntryUpdateAbsenceEntryPost$Params, context?: HttpContext): Observable<void> {
    const resp = this.apiV0AbsenceEntryUpdateAbsenceEntryPost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiV0AbsenceEntryApproveAbsenceEntryPost()` */
  static readonly ApiV0AbsenceEntryApproveAbsenceEntryPostPath = '/api/v0/absenceEntry/approveAbsenceEntry';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0AbsenceEntryApproveAbsenceEntryPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0AbsenceEntryApproveAbsenceEntryPost$Response(params?: ApiV0AbsenceEntryApproveAbsenceEntryPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = apiV0AbsenceEntryApproveAbsenceEntryPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0AbsenceEntryApproveAbsenceEntryPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0AbsenceEntryApproveAbsenceEntryPost(params?: ApiV0AbsenceEntryApproveAbsenceEntryPost$Params, context?: HttpContext): Observable<void> {
    const resp = this.apiV0AbsenceEntryApproveAbsenceEntryPost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiV0AbsenceEntryRejectAbsenceEntryPost()` */
  static readonly ApiV0AbsenceEntryRejectAbsenceEntryPostPath = '/api/v0/absenceEntry/rejectAbsenceEntry';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0AbsenceEntryRejectAbsenceEntryPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0AbsenceEntryRejectAbsenceEntryPost$Response(params?: ApiV0AbsenceEntryRejectAbsenceEntryPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = apiV0AbsenceEntryRejectAbsenceEntryPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0AbsenceEntryRejectAbsenceEntryPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0AbsenceEntryRejectAbsenceEntryPost(params?: ApiV0AbsenceEntryRejectAbsenceEntryPost$Params, context?: HttpContext): Observable<void> {
    const resp = this.apiV0AbsenceEntryRejectAbsenceEntryPost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiV0AbsenceEntryDeleteByIdDelete()` */
  static readonly ApiV0AbsenceEntryDeleteByIdDeletePath = '/api/v0/absenceEntry/deleteById';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0AbsenceEntryDeleteByIdDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0AbsenceEntryDeleteByIdDelete$Response(params?: ApiV0AbsenceEntryDeleteByIdDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = apiV0AbsenceEntryDeleteByIdDelete(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0AbsenceEntryDeleteByIdDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0AbsenceEntryDeleteByIdDelete(params?: ApiV0AbsenceEntryDeleteByIdDelete$Params, context?: HttpContext): Observable<void> {
    const resp = this.apiV0AbsenceEntryDeleteByIdDelete$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiV0AbsenceEntryDeleteMultipleDelete()` */
  static readonly ApiV0AbsenceEntryDeleteMultipleDeletePath = '/api/v0/absenceEntry/deleteMultiple';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0AbsenceEntryDeleteMultipleDelete()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV0AbsenceEntryDeleteMultipleDelete$Response(params?: ApiV0AbsenceEntryDeleteMultipleDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = apiV0AbsenceEntryDeleteMultipleDelete(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0AbsenceEntryDeleteMultipleDelete$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV0AbsenceEntryDeleteMultipleDelete(params?: ApiV0AbsenceEntryDeleteMultipleDelete$Params, context?: HttpContext): Observable<void> {
    const resp = this.apiV0AbsenceEntryDeleteMultipleDelete$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
